import { MerchantMarketingConfig } from './interfaces';

export enum MarketingActionType {
  CHANGE_UPDATE_CHECKOUT_THEME = 'MARKETING/CHANGE_UPDATE_CHECKOUT_THEME',
  GET_MERCHANT_MARKETING_CONFIG = 'MARKETING/GET_MERCHANT_MARKETING_CONFIG',
  GET_MERCHANT_MARKETING_CONFIG_SUCCESS = 'MARKETING/GET_MERCHANT_MARKETING_CONFIG_SUCCESS',
  GET_MERCHANT_MARKETING_CONFIG_ERROR = 'MARKETING/GET_MERCHANT_MARKETING_CONFIG_ERROR',
  UPDATE_MERCHANT_MARKETING_CONFIG = 'MARKETING/UPDATE_MERCHANT_MARKETING_CONFIG',
  UPDATE_MERCHANT_MARKETING_CONFIG_SUCCESS = 'MARKETING/UPDATE_MERCHANT_MARKETING_CONFIG_SUCCESS',
  UPDATE_MERCHANT_MARKETING_CONFIG_ERROR = 'MARKETING/UPDATE_MERCHANT_MARKETING_CONFIG_ERROR',
}

export const getMerchantMarketingConfig = () => ({
  type: MarketingActionType.GET_MERCHANT_MARKETING_CONFIG,
});

export const getMerchantMarketingConfigSuccess = (response: any) => ({
  type: MarketingActionType.GET_MERCHANT_MARKETING_CONFIG_SUCCESS,
  response,
});

export const getMerchantMarketingConfigError = (error: any) => ({
  type: MarketingActionType.GET_MERCHANT_MARKETING_CONFIG_ERROR,
  error,
});

export const updateMerchantMarketingConfig = (payload: MerchantMarketingConfig) => ({
  type: MarketingActionType.UPDATE_MERCHANT_MARKETING_CONFIG,
  payload,
});

export const updateMerchantMarketingConfigSuccess = (response: MerchantMarketingConfig) => ({
  type: MarketingActionType.UPDATE_MERCHANT_MARKETING_CONFIG_SUCCESS,
  response,
});

export const updateMerchantMarketingConfigError = (response: MerchantMarketingConfig) => ({
  type: MarketingActionType.UPDATE_MERCHANT_MARKETING_CONFIG_ERROR,
  response,
});
